import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import SarfTwreed from "./SarfTwreed";
const defaultAutos = {
  Safes: [],
};

export default function TwreedSafesCon() {
  
  
  const tb = {
    wait: true,
    Safe: true,
    SafeEmp:true,
    Branch: true,
    costcenters:true,
    other: true,
    Units: true,
    EmpItems:true,
    Users:true,
    MedAccounts:true,
    AllAccountsIndex:true,
    omlats: true,
    PermissionsElemnts:true,
    stor: sto,

    parms: { safe: -1,
        tname:"twreed" ,
        medname:"twreed" , 
        iempid: sto.empi,
        branch:sto.branchi,
        iformid: 70007,
    },
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb
  );

  if (fetchAll || !AutoOptions?.Safes) return <LoadingPage />;

  return (
    <SarfTwreed
      {...{
        AutoOptions: AutoOptions?.Safes ? AutoOptions : defaultAutos,
        IsSarf:false,
      }}
    />
  );
}
